import React, {useEffect,useState} from "react"
import alanBtn from "@alan-ai/alan-sdk-web";
import Newscard from "./Component/Newscard/Newscard"
import wordsToNumbers from "words-to-numbers";
const alanKey='5d88918a1ca328b42688f63e32efb6562e956eca572e1d8b807a3e2338fdd0dc/stage'
const App =()=>{
  const [newsArticles,setNewsArticles]=useState([ ]);
  const [activearticle,setactivearticle]=useState(-1);
  useEffect(()=>{
    alanBtn({
      key: alanKey,
      onCommand: ({command,articles,number})=>{
        if(command==='newHeadlines'){
          console.log(articles);
          setNewsArticles(articles);
          setactivearticle(-1);
        }else if(command==='highlight'){
          setactivearticle((prevActiveArticle)=> prevActiveArticle + 1)
        }else if(command==='open'){
          const parseNumber=number.length > 2 ? wordsToNumbers(number, {fuzzy:true}):number;
          window.open(articles[parseNumber-1].url,'_blank');
        }else if(command==='openportfolio'){
          window.open('https://vedant-jain03.github.io/portfolio/','_blank');
        }
      }
    })
  },[])
  return(
    <div>
      <h1><center>Welcome To Read-My-News</center></h1>
      <Newscard articles={newsArticles} activearticle={activearticle} />
    </div>
  )
}
export default App;